import React, { useRef } from 'react'
import './Join.css'
import emailjs from '@emailjs/browser'

const Join = () => {      

    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs
        .sendForm('service_do08gkw', 'template_vsfc0s8', form.current, {
          publicKey: 'rYinn2OxqofBMthCe',
        })
        .then(
          () => {
            console.log('SUCCESS!');
          },
          (error) => {
            console.log('FAILED...', error.text);
          },
        );
      };
  return (
    <div className="Join" id="join">
        <div className="left-j">
            <hr />
            <div>
                <span className='stroke-txt'>READY TO</span>
                <span> LEVEL UP</span>
            </div>
            <div>
                <span>YOUR BODY</span>
                <span className='stroke-txt'> WITH US?</span>
            </div>
        </div>
        <div className="right-j">
            <form ref={form} action="" className='email-container' onSubmit={sendEmail}>
                <input type="email" name="user_email" placeholder='Enter Your Email' />
                <button className='btn btn-j'>JOIN NOW </button>
            </form>
        </div>
    </div>
  )
}

export default Join